import { useEffect, useState } from 'preact/hooks';
import type { PrListBody, PrSummary } from '../../shared/pr/api';
import { ApiError, apiGet } from './api';

export type ListState =
  | { kind: 'loading' }
  | { kind: 'error'; reference: string | null }
  | { kind: 'ok'; requests: PrSummary[] };

/** The signed-in person's own requests (GET /api/prs). */
export function useMyRequests(): ListState {
  const [state, setState] = useState<ListState>({ kind: 'loading' });
  useEffect(() => {
    let live = true;
    apiGet<PrListBody>('/api/prs')
      .then((b) => live && setState({ kind: 'ok', requests: b.requests }))
      .catch((err: unknown) => {
        if (live)
          setState({
            kind: 'error',
            reference: err instanceof ApiError ? err.correlationId : null,
          });
      });
    return () => {
      live = false;
    };
  }, []);
  return state;
}
